import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Agent Chat sidebar is opened or closed',
  name: 'canvas_agent_chat_panel_toggled',
  params: [
    {
      description: 'Whether the panel was opened or closed',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['opened', 'closed'],
    },
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
